import React, { Fragment, useState, useContext } from "react";
import {
  Grid,
  Card,
  Button,
  Typography,
  IconButton,
  FormControl,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { IoIosTrash, IoMdSettings } from "react-icons/io";
import { FiPlus } from "react-icons/fi";
import Addmore from "./addmore";
import { ServiceContext } from "../../../Context/ServiceContext";
import useReactRouter from "use-react-router";
import { editServiceMore } from "../../../API/Service";
import { useSnackbar } from "notistack";
import { editFiberObtic, getFiberObtic } from "../../../API/Fiber";
import { LangContext } from "../../../Context/Langcontext";

const useStyle = makeStyles((theme) => ({
  cardstyle: {
    width: "100%",
    backgroundColor: "#FFFFFF",
    boxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    WebkitBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    MozBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    borderRadius: 8,
    marginBottom: "0.1rem",
    minHeight: "calc(100vh - 35.9rem)",
    maxHeight: "100%",
  },
  griditemhead: {
    display: "flex",
    alignItems: "center",
    margin: "0rem 0rem 1rem 0rem",
  },
  griditemheadend: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    margin: "0rem 0rem 1rem 0rem",
  },
  containerhead: {
    // borderBottom: "1px solid #d9d9d9",
  },
  gridcontent: {
    borderBottom: "1px solid #d9d9d9",
    margin: "0rem 0.3rem",
  },
  servicename: {
    margin: "0.7rem 0rem",
    fontWeight: 200,
    color: "#595a5a",
  },
  fontService: {
    fontWeight: 700,
    color: "#595a5a",
    fontSize: "1.2rem",
  },
  itemcontent: {
    display: "flex",
    width: "100%",
    alignItems: "center",
    justifyContent: "space-between",
  },
  icon: { color: "#828282" },
  addbtn: {
    padding: "0.5rem 3rem",
    fontSize: "1rem",
    fontWeight: 200,
    textTransform: "unset",
    backgroundColor: "#98a8c1",
    color: "#FFFFFF",
    "&:hover": {
      backgroundColor: "#98a8c1",
      boxShadow: `0px 0px 20px -1px #a8a8a8`,
      transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    },
    borderRadius: 8,
  },
  subhead: {
    margin: "0.7rem 0rem",
    fontWeight: 700,
    color: "#595a5a",
  },
  cardaddstyle: {
    width: "100%",
    backgroundColor: "#FFFFFF",
    boxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    WebkitBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    MozBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    borderRadius: 8,
    marginBottom: "0.1rem",
    maxHeight: "calc(100vh - 29.9rem)",
    overflowY: "auto",
  },
  check: {
    "& .MuiFormControlLabel-labelPlacementStart": {},
  },
  nodata: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "calc(100vh - 52rem)",
    borderTop: "1px solid #d9d9d9",
  },
  cardfiber: {
    width: "100%",
    backgroundColor: "#FFFFFF",
    boxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    WebkitBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    MozBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    borderRadius: 8,
    marginBottom: "0.1rem",
    maxHeight: "100%",
  },
  label: {
    fontWeight: 400,
    color: "#595a5a",
  },
  fibername: {
    margin: "0.7rem 0rem",
    fontWeight: 200,
    color: "#E16733",
  },
}));
const DefineData = ({ data, setfetch, fiber, role }) => {
  const classes = useStyle();
  const serviceContext = useContext(ServiceContext);
  const langContext = useContext(LangContext);
  const lang = langContext.lang.data;
  const { match } = useReactRouter();
  const { enqueueSnackbar } = useSnackbar();
  const [open, setOpen] = useState(false);
  const [checked, setChecked] = useState([]);
  const [loading, setloading] = useState(false);
  const [remove, setRemove] = useState(false);
  const [collect, setCollect] = useState({});
  const [addfiber, setAddFiber] = useState(false);
  const [fiberlist, setfiberlist] = useState([]);

  // const dataForUser = serviceContext.data.filter(s => s.category === 'data' && s.user_roles.find(r => r === role))

  const onRemoveClose = () => {
    setRemove(false);
  };

  const onClose = () => {
    setOpen(false);
    setChecked([]);
    const checkdata = [...serviceContext.data];

    let addcheck = checkdata.map((rs) => {
      let respon = rs;
      respon.isCheck = false;

      return respon;
    });
    serviceContext.setData(addcheck);
  };

  const addmoreData = (serdata) => {
    let add = serdata.filter((rs) => {
      return rs.category === "data";
    });
    let addcheck = add.map((rs) => {
      let respon = rs;
      if (rs.isCheck) {
        respon.isCheck = rs.isCheck;
      } else {
        respon.isCheck = false;
      }
      return respon;
    });

    for (let i = 0; i < data.length; i++) {
      let filter = addcheck.filter((rs) => {
        return rs._id === data[i]._id;
      });
      if (filter.length !== 0) {
        let index = addcheck
          .map((r) => {
            return r._id;
          })
          .indexOf(data[i]._id);
        addcheck.splice(index, 1);
      } else {
      }
    }
    return addcheck;
  };

  const onChangeData = (i, e) => {
    let d = [...addmoreData(serviceContext.data)];
    const checkdata = [...serviceContext.data];
    let id = checkdata
      .map((item) => {
        return item._id;
      })
      .indexOf(d[i]._id);
    checkdata[id].isCheck = e.target.checked;

    if (checked.includes(checkdata[id]._id)) {
      const datacheck = checked.filter((f) => {
        return f !== checkdata[id]._id;
      });
      setChecked(datacheck);
    } else {
      setChecked([...checked, checkdata[id]._id]);
    }

    serviceContext.setData(checkdata);
  };

  const onAddmore = async () => {
    setloading(true);
    if (checked.length !== 0) {
      const onData = checked.map((rs) => {
        let objdata = {};
        let datafind = serviceContext.data.find((r) => {
          return r._id === rs;
        });
        if (datafind.user_specials) {
          if (datafind.user_specials.includes(match.params.id)) {
          } else {
            datafind.user_specials.push(match.params.id);
          }
        } else {
          datafind.user_specials = [];
          datafind.user_specials.push(match.params.id);
        }

        objdata = datafind;

        return objdata;
      });

      let respon = [];
      console.log(onData);
      onData.map(async (item) => {
        let edit = await editServiceMore(item._id, item);
        if (edit.status.code === 200) {
          respon.push(true);
        } else {
          respon.push(false);
        }
        return edit;
      });

      const resolve = await Promise.all(onData);
      if (resolve.length) {
        setloading(false);
        setOpen(false);
        setfetch(false);
        setloading(false);
        setOpen(false);
        setChecked([]);
        const checkdata = [...serviceContext.data];

        let addcheck = checkdata.map((rs) => {
          let respons = rs;
          respons.isCheck = false;

          return respons;
        });
        console.log(addcheck);
        serviceContext.setData(addcheck);
        enqueueSnackbar(
          `${lang.addservice} ${resolve.length} ${lang.of} ${resolve.length}`,
          {
            variant: "success",
          }
        );
      }
      // setTimeout(() => {
      //   enqueueSnackbar(
      //     `${lang.addservice} ${
      //       respon.filter((rs) => {
      //         return rs === true;
      //       }).length
      //     } ${lang.of} ${respon.length}`,
      //     {
      //       variant: "success",
      //     }
      //   );
      //   setloading(false);
      //   setOpen(false);
      //   setfetch(false);
      //   setChecked([]);
      //   const checkdata = [...serviceContext.data];

      //   let addcheck = checkdata.map((rs) => {
      //     let respons = rs;
      //     respons.isCheck = false;

      //     return respons;
      //   });
      //   serviceContext.setData(addcheck);
      // }, 2000);
    } else {
      setOpen(false);
    }
  };

  const onCheckAll = (e) => {
    const checkdata = [...serviceContext.data];

    let addcheck = checkdata.map((rs) => {
      let respon = rs;
      if (e.target.checked) {
        respon.isCheck = true;
      } else {
        respon.isCheck = false;
      }
      return respon;
    });

    if (checked.length === addmoreData(serviceContext.data).length) {
      setChecked([]);
    } else {
      let arr = [];
      addmoreData(serviceContext.data).map((rs) => {
        return arr.push(rs._id);
      });
      setChecked(arr);
    }

    serviceContext.setData(addcheck);
  };

  const onRemoveData = async () => {
    setloading(true);
    if (collect.user_specials.includes(match.params.id)) {
      const input = collect.user_specials.filter((rs) => {
        return rs !== match.params.id;
      });
      let inputedit = { ...collect };
      inputedit.user_specials = input;

      let edit = await editServiceMore(collect._id, inputedit);

      if (edit.status.code === 200) {
        const checkdata = [...serviceContext.data];

        let addcheck = checkdata.map((rs) => {
          let respon = rs;
          respon.isCheck = false;

          return respon;
        });

        serviceContext.setData(addcheck);

        setloading(false);
        setRemove(false);
        setfetch(false);
        setChecked([]);
        setCollect({});

        enqueueSnackbar(lang.RemoveService, {
          variant: "success",
        });
      } else {
        enqueueSnackbar(lang.RemoveServiceError, {
          variant: "error",
        });
      }
    }
  };

  const find_check = (data) => {
    let checknumber = data ? [...data] : [...serviceContext.fiber];
    let item = checknumber.map((rs) => {
      let num = 0;
      if (rs.user_ids) {
        if (rs.user_ids.includes(match.params.id)) {
          return num + 1;
        }
      } else {
      }
      return num;
    });
    let truenum = item.filter((rs) => {
      return rs === 1;
    });
    return truenum.length;
  };

  const onAllFiber = (e) => {
    let fbdata = [...serviceContext.fiber];

    let addcheck = fbdata.map((rs) => {
      if (rs.user_ids !== undefined) {
        if (rs.user_ids.includes(match.params.id)) {
          //checked
          if (e.target.checked) {
            serviceContext.setFiber(fbdata);
          } else {
            let fbuser = rs.user_ids.filter((res) => {
              return res !== match.params.id;
            });

            rs.user_ids = fbuser;
            serviceContext.setFiber(fbdata);
          }
        } else {
          //unchecked
          if (e.target.checked) {
            rs.user_ids.push(match.params.id);
            serviceContext.setFiber(fbdata);
          } else {
            let fbuser = rs.user_ids.filter((res) => {
              return res !== match.params.id;
            });
            rs.user_ids = fbuser;
            serviceContext.setFiber(fbdata);
          }
        }
      } else {
        rs.user_ids = [];
        rs.user_ids.push(match.params.id);
        serviceContext.setFiber(fbdata);
      }
      return rs;
    });
    if (e.target.checked) {
      setfiberlist(addcheck);
    } else {
      console.log(addcheck);
      setfiberlist(addcheck);
    }
    find_check(addcheck);
  };

  const onGetFiber = (dt, ind) => {
    let filter = fiberlist.filter((rs) => {
      return rs._id === dt._id;
    });

    let fbdata = [...serviceContext.fiber];
    if (fbdata[ind].user_ids !== undefined) {
      if (fbdata[ind].user_ids.includes(match.params.id)) {
        let fbuser = fbdata[ind].user_ids.filter((rs) => {
          return rs !== match.params.id;
        });

        fbdata[ind].user_ids = fbuser;
        serviceContext.setFiber(fbdata);
      } else {
        fbdata[ind].user_ids.push(match.params.id);
        serviceContext.setFiber(fbdata);
      }
    } else {
      fbdata[ind].user_ids = [];
      fbdata[ind].user_ids.push(match.params.id);
      serviceContext.setFiber(fbdata);
    }

    if (filter.length !== 0) {
      let ind = fiberlist
        .map((rs) => {
          return rs._id;
        })
        .indexOf(dt._id);
      let newdata = [...fiberlist];
      newdata.splice(ind, 1);
      setfiberlist(newdata);
    } else {
      let newdata = [...fiberlist];
      newdata.push(dt);
      setfiberlist(newdata);
    }
  };

  const onUpdate = async () => {
    setloading(true);
    let times = [];

    serviceContext.fiber.map(async (item) => {
      let edit = await editFiberObtic(item._id, item);

      if (edit.status.code === 200) {
        times.push(true);
      } else {
        times.push(false);
      }
    });

    const resolve = await Promise.all(fiberlist);

    if (resolve.length) {
      setloading(false);
      setAddFiber(false);
      setfetch(false);
      setfiberlist([]);
      enqueueSnackbar(`${lang.Updatefiber}`, {
        variant: "success",
      });
    }
  };

  return (
    <Fragment>
      <Grid item xs={12}>
        <Card className={classes.cardstyle}>
          <div style={{ margin: "1rem 2rem 2rem 2rem" }}>
            <Grid container className={classes.containerhead}>
              <Grid item xs={6} className={classes.griditemhead}>
                <Typography className={classes.fontService}>
                  Service List
                </Typography>
              </Grid>
              <Grid item xs={6} className={classes.griditemheadend}>
                <Button
                  className={classes.addbtn}
                  startIcon={<FiPlus />}
                  variant="contained"
                  onClick={() => {
                    setOpen(true);
                  }}
                >
                  {langContext.lang.locale === "th"
                    ? lang.Add
                    : `${lang.Add} more`}
                </Button>
              </Grid>
            </Grid>
            <Grid container style={{ borderTop: "1px solid #d9d9d9" }}>
              {data.length !== 0 ? (
                data.map((rs, index) => {
                  return (
                    <Grid
                      key={rs._id}
                      item
                      xs={12}
                      className={classes.gridcontent}
                      style={{
                        backgroundColor:
                          index % 2 === 1 ? "#f9f9f9" : "#FFFFFF",
                      }}
                    >
                      <div className={classes.itemcontent}>
                        <div>
                          <Typography
                            className={classes.servicename}
                            style={{ marginLeft: "0.3rem" }}
                          >
                            {`${index + 1}. ${rs.name}`}
                          </Typography>
                        </div>
                        <div>
                          {rs.default ? null : (
                            <IconButton
                              onClick={() => {
                                setRemove(true);
                                setCollect(rs);
                              }}
                            >
                              <IoIosTrash className={classes.icon} />
                            </IconButton>
                          )}
                        </div>
                      </div>
                    </Grid>
                  );
                })
              ) : (
                <div className={classes.nodata}> {lang.NoService}</div>
              )}
            </Grid>
          </div>
        </Card>
      </Grid>

      <Grid item xs={12} style={{ margin: "2rem 0rem 0rem 0rem" }}>
        <Card className={classes.cardfiber}>
          <div style={{ margin: "1rem 2rem 2rem 2rem" }}>
            <Grid container className={classes.containerhead}>
              <Grid item xs={6} className={classes.griditemhead}>
                <Typography className={classes.fontService}>
                  Fiber - optic
                </Typography>
              </Grid>
              <Grid item xs={6} className={classes.griditemheadend}>
                {/* <IconButton
                  onClick={() => {
                    setAddFiber(true);
                  }}
                >
                  <IoMdSettings />
                </IconButton> */}
                <Button
                  className={classes.addbtn}
                  endIcon={<IoMdSettings />}
                  variant="contained"
                  onClick={() => {
                    setAddFiber(true);
                  }}
                >
                  {lang.Setting}
                </Button>
              </Grid>
            </Grid>
            <Grid container style={{ borderTop: "1px solid #d9d9d9" }}>
              {fiber.map((rs) => {
                return rs.user_ids !== undefined ? (
                  rs.user_ids.includes(match.params.id) ? (
                    <Grid item xs={12} key={rs._id}>
                      <Typography className={classes.fibername}>
                        {rs.name}
                      </Typography>
                    </Grid>
                  ) : null
                ) : null;
              })}
            </Grid>
          </div>
        </Card>
      </Grid>

      <Addmore
        handleClose={onClose}
        open={open}
        header={lang.AddmoreData}
        onSubmit={onAddmore}
        checked={checked}
        loading={loading}
      >
        <Grid container>
          <Grid item xs={12} style={{ margin: "0rem 1.5rem 0.5rem 0rem" }}>
            <div className={classes.itemcontent}>
              <div>
                <Typography
                  className={classes.subhead}
                  style={{ marginLeft: "0.3rem" }}
                >
                  {lang.ElectronicDataAPI}
                </Typography>
              </div>
              <div>
                <FormControl component="fieldset">
                  <FormControlLabel
                    classes={{ label: classes.label }}
                    value="top"
                    control={
                      <Checkbox
                        checked={
                          checked.length ===
                          addmoreData(serviceContext.data).length
                        }
                        color="primary"
                      />
                    }
                    onClick={(e) => {
                      onCheckAll(e);
                    }}
                    label={
                      langContext.lang.locale === "th"
                        ? `เลือก${lang.All}`
                        : lang.All
                    }
                    labelPlacement="start"
                  />
                </FormControl>
              </div>
            </div>
          </Grid>
        </Grid>
        <Card className={classes.cardaddstyle}>
          <div style={{ margin: "1rem 1rem" }}>
            <Grid container>
              {open ? (
                addmoreData(serviceContext.data).length !== 0 ? (
                  addmoreData(serviceContext.data).map((rs, index) => {
                    return (
                      <Grid
                        key={rs._id}
                        item
                        xs={12}
                        className={classes.gridcontent}
                        style={{
                          backgroundColor:
                            index % 2 === 1 ? "#f9f9f9" : "#FFFFFF",
                        }}
                      >
                        <div className={classes.itemcontent}>
                          <div>
                            <Typography
                              className={classes.servicename}
                              style={{ marginLeft: "0.3rem" }}
                            >
                              {`${rs.name}`}
                            </Typography>
                          </div>
                          <div>
                            <Checkbox
                              className={classes.check}
                              checked={rs.isCheck}
                              onChange={(e) => {
                                onChangeData(index, e);
                              }}
                              color="primary"
                              inputProps={{
                                "aria-label": "secondary checkbox",
                              }}
                            />
                          </div>
                        </div>
                      </Grid>
                    );
                  })
                ) : (
                  <div>{lang.NoService}</div>
                )
              ) : null}
            </Grid>
          </div>
        </Card>
      </Addmore>

      <Addmore
        handleClose={onRemoveClose}
        open={remove}
        header={lang.RemoveelectronicdataAPI}
        onSubmit={onRemoveData}
        checked={["-"]}
        loading={loading}
      >
        {langContext.lang.locale === "th"
          ? `${lang.RemoveDialog}${lang.Service.toLowerCase()} ${
              collect.name
            } ?`
          : `Do you want to remove ${collect.name} service ?`}
      </Addmore>

      <Addmore
        handleClose={async () => {
          const fiber = await getFiberObtic();
          setAddFiber(false);
          if (fiber.status.code === 200) {
            serviceContext.setFiber(fiber.data);
          } else {
          }
          setfiberlist([]);
        }}
        open={addfiber}
        header={lang.SelectOwner}
        onSubmit={onUpdate}
        checked={fiberlist}
        loading={loading}
      >
        <Grid container>
          <Grid item xs={12} style={{ margin: "0rem 0rem 0.5rem 0rem" }}>
            <div className={classes.itemcontent}>
              <div>
                <Typography className={classes.subhead}>
                  {lang.Ownerlist}
                </Typography>
              </div>
              <div>
                <FormControl component="fieldset">
                  <FormControlLabel
                    classes={{ label: classes.label }}
                    value="top"
                    control={
                      <Checkbox
                        checked={serviceContext.fiber.length === find_check()}
                        color="primary"
                      />
                    }
                    onClick={(e) => {
                      onAllFiber(e);
                      // onCheckAll(e);
                    }}
                    label={
                      langContext.lang.locale === "th"
                        ? `เลือก${lang.All}`
                        : lang.All
                    }
                    labelPlacement="start"
                  />
                </FormControl>
              </div>
            </div>
          </Grid>
        </Grid>
        <Card className={classes.cardaddstyle}>
          <div style={{ margin: "1rem 1rem" }}>
            <Grid container>
              {addfiber ? (
                serviceContext.fiber.length !== 0 ? (
                  serviceContext.fiber.map((rs, index) => {
                    return (
                      <Grid
                        key={rs._id}
                        item
                        xs={12}
                        className={classes.gridcontent}
                        style={{
                          backgroundColor:
                            index % 2 === 1 ? "#f9f9f9" : "#FFFFFF",
                        }}
                      >
                        <div className={classes.itemcontent}>
                          <div>
                            <Typography
                              className={classes.servicename}
                              style={{ marginLeft: "0.3rem" }}
                            >
                              {`${rs.name}`}
                            </Typography>
                          </div>
                          <div>
                            <Checkbox
                              checked={
                                rs.user_ids !== undefined
                                  ? rs.user_ids.includes(match.params.id)
                                  : false
                              }
                              className={classes.check}
                              onChange={(e) => {
                                onGetFiber(rs, index);
                              }}
                              color="primary"
                              inputProps={{
                                "aria-label": "secondary checkbox",
                              }}
                            />
                          </div>
                        </div>
                      </Grid>
                    );
                  })
                ) : (
                  <div>{lang.NoService}</div>
                )
              ) : null}
            </Grid>
          </div>
        </Card>
      </Addmore>
    </Fragment>
  );
};

export default DefineData;
